import React from 'react';

type AudioVisualizerProps = {
    audioData: Uint8Array;
};
type AudioVisualizerState = {
    audioData: any;
};
class AudioVisualiser extends React.Component<AudioVisualizerProps, AudioVisualizerState> {

    wave: number[];

    timer: number;

    constructor(props: any) {
        super(props);
        this.wave = [];
        this.timer = 0;
    }

    componentDidUpdate() {
        this.draw();
    }

    draw() {
        this.timer++;
        if (this.timer > 1) {
            this.timer = 0;
            const { audioData } = this.props;
            this.wave = [audioData[0], ...this.wave].slice(0, 30)
        }

    }

    getval(he: number) {
        let v = he === 0 ? 2 : he
        v = v > 18 ? 18 : v
        return v
    }

    render() {
        return <div className='flex flex-row gap-[2px] w-[160px] h-[32px] bg-primary-200 rounded-lg items-center'>
            {
                this.wave.map((val, index) => {
                    let he = (val - 125);
                    he = this.getval(he)
                    const key = `key${index}`
                    return (
                        <div className='w-[4px] bg-primary rounded-lg' key={key} style={{ height: `${he}px` }}>

                        </div>)
                })
            }
        </div>


    }
}

export default AudioVisualiser;